import React from "react";

const YouTube = () => {
  return (
    <div className="flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-lg">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-8 h-8 text-red-600"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M21.8 8.001c-.25-1.31-1.31-2.32-2.62-2.57C17.6 5.001 12 5.001 12 5.001s-5.6 0-7.18.431a2.99 2.99 0 0 0-2.62 2.57C2 9.6 2 12 2 12s0 2.4.2 3.999c.25 1.31 1.31 2.32 2.62 2.57 1.58.43 7.18.43 7.18.43s5.6 0 7.18-.431a2.99 2.99 0 0 0 2.62-2.57C22 14.4 22 12 22 12s0-2.4-.2-3.999zM9.75 15.02V8.98L15.25 12l-5.5 3.02z" />
      </svg>
    </div>
  );
};

export default YouTube;
